export const SENSAY_ORGANIZATION_UUID = 'a266dd3b-a474-4cde-9dbd-c0a956dbd23c'
export const SENSAY_API_VERSION = '2025-03-25'
export const JWT_LOCALSTORAGE_KEY = 'fingerprinted-jwt-v2'
export const MOBILE_BREAKPOINT = 640
